export const formatCommandItem = (quantity, description) => (
  `${String(quantity ?? '').trim() || '0'} ${String(description || '-').trim()}`
);

export const formatOrderProductDescription = (description, orderProductVariants = []) => {
  const variantNames = (Array.isArray(orderProductVariants) ? orderProductVariants : [])
    .map((entry) => entry?.variant?.name || entry?.name)
    .map((name) => String(name || '').trim())
    .filter(Boolean);

  return variantNames.length > 0
    ? `${String(description || '-').trim()} + ${variantNames.join(' + ')}`
    : String(description || '-').trim();
};

export const formatCourseHeading = (courseIndex, courseName = '') => {
  const name = String(courseName || '').trim();
  return `PORTATA ${courseIndex}${name && name.toUpperCase() !== 'PORTATA' ? ` - ${name}` : ''}`;
};

export const formatCourseSeparator = (hasNextCourse) => (
  hasNextCourse ? '---------- SEGUE ----------' : '--------------------------------'
);
